import {FormGroup, ValidatorFn, Validators} from '@angular/forms';

export class CustomValidators {

    public static passwordMatchValidator: ValidatorFn = (fg: FormGroup) => {
        const start = fg.get('password').value;
        const end = fg.get('passwordconfirm').value;
        let result = start !== null && end !== null && start == end
            ? null
            : { notConfirmed: true };
        return result;
    };

    public static passwordTheSameValidator: ValidatorFn = (fg: FormGroup) => {
        const start = fg.get('password').value;
        const end = fg.get('passwordold').value;
        let result = start !== null && end !== null && start !== end
            ? null
            : { theSame: true };
        return result;
    }

    public static passwordFieldValidators() {
        return [
            Validators.required,
            Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^a-zA-Z0-9])(?=.{8,30})/),
            Validators.minLength(8),
            Validators.maxLength(30)]
    }
}
